import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { TEntryField } from '../../data/ProcData'
import { TSteadyStep } from '../../data/WorkflowSteps'
import aGetFormCompletion from './aGetFormCompletion'
import DF, { DataViewNumberField as VF } from './DataNumberField'
import EntryItem from './RampupEntryItem'
import { useAppSelector } from './RunReduxHooks'
import { selectData } from './sliceTimeline'

export const fieldList:TEntryField[] = [
    'LAGlucose', 'LALactate', 
    'LApH', 'LAPCO2', 'LAPO2', 
    'PApH', 'PAPCO2', 'PAPO2',
]


/* This is the list of mandatory fields to accomodate salts as mandatory input 
export const fieldList:TEntryField[] = [
    'LAGlucose', 'LALactate', 
    'LApH', 'LAPCO2', 'LAPO2', 
    'PApH', 'PAPCO2', 'PAPO2',
    'LANaPlus', 'LAClMinus', 'LAHCO3Minus',
    'LAKPlus', 'LACa2Plus', 'LABEcf'     
]
*/

export default function ATab3BGA({completion} : {completion: (allChecked: boolean) => void}) {
    const { step } = useParams()
    const stepData = useAppSelector(selectData)
    
    useEffect(() => {
        completion(aGetFormCompletion(stepData, step as TSteadyStep, fieldList))
    }, [stepData, step, completion])

    const GRIDSPACING = 2
    return (
        <>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={4}>
                        <DF step={step} field='LApH' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='LAPCO2' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='LAPO2' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={6}>
                        <DF step={step} field='LAGlucose' fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        <DF step={step} field='LALactate' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={4}>
                        <DF step={step} field='PApH' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='PAPCO2' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='PAPO2' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <VF step={step} field='DeltaPF' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                </Grid>
            </EntryItem>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={4}>
                        <DF step={step} field='LANaPlus' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='LAClMinus' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='LAHCO3Minus' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='LAKPlus' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='LACa2Plus' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='LABEcf' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>

        </>
    )

}